module.exports = __webpack_public_path__ + "img/btn-samarbejde.5a58ab33.png";